<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/requisicaoServico">
        Compras/Requisição/Requisição Serviço
      </router-link>
      <label class="labelBar"> / </label>
      <label>
        {{
          modoAprovacaoLimite
            ? "Aprovar Pedido Requisição Serviço"
            : ["AL", "LD", "PG"].includes(requisicaoServico.status)
            ? "Editar Cotação Requisição Serviço"
            : "Gerar Pedido Requisição Serviço"
        }}
      </label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="fornecedorSelected"
              :items="filteredFornecedor"
              label="Fornecedor *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="somenteLeituraCotacao"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Orçamento nº"
              v-model="requisicaoServico.orcamento"
              :counter="200"
              :readonly="somenteLeituraCotacao"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="condicaoPagamentoSelected"
              :items="condicoes"
              item-value="id"
              item-text="descricao"
              label="Pagamento"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Pagamento é obrigatório']"
              required
              :readonly="somenteLeituraCotacao"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              label="Requisição"
              v-model="requisicaoServico.id"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Observação"
              auto-grow
              v-model="requisicaoServico.observacaoPedido"
              rows="1"
              :readonly="somenteLeituraCotacao"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-card>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="produtosL"
            :items-per-page="-1"
          >
            <template v-slot:item.marca="{ item }">
              <v-text-field v-model="item.marca" :readonly="somenteLeituraCotacao">
              </v-text-field>
            </template>
            <template v-slot:item.prazo="{ item }">
              <v-text-field
                v-model.number="item.prazo"
                type="number"
                v-mask="['#####']"
                :readonly="somenteLeituraCotacao"
              >
              </v-text-field>
            </template>
            <template v-slot:item.valorUnitario="{ item }">
              <v-text-field
                :value="item.valorUnitarioLocal"
                @input="(val) => onInput(val, item, 'valorUnitario')"
                @focus="posicionarCursorFim"
                @click="posicionarCursorFim"
                inputmode="numeric"
                type="text"
                :readonly="somenteLeituraCotacao"
              />
            </template>
            <template v-slot:item.desconto="{ item }">
              <v-text-field
                :value="item.descontoLocal"
                @input="(val) => onInput(val, item, 'desconto')"
                @focus="posicionarCursorFim"
                @click="posicionarCursorFim"
                inputmode="numeric"
                type="text"
                :readonly="somenteLeituraCotacao"
              />
            </template>
          </v-data-table>
        </v-card>
        <v-row align="center">
          <v-col cols="12" sm="7"> </v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Subtotal:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              hide-details
              @input="calcularTotais()"
              v-model="requisicaoServico.subtotal"
              class="mt-0 pt-0"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="7"> </v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Acréscimo:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="requisicaoServico.acrescimoLocal"
              @input="(val) => onInput(val, null, 'acrescimo')"
              @focus="posicionarCursorFim"
              @click="posicionarCursorFim"
              class="mt-0 pt-0"
              inputmode="numeric"
              type="text"
              :readonly="somenteLeituraCotacao"
            />
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Desconto:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="requisicaoServico.descontoLocal"
              @input="(val) => onInput(val, null, 'descontoadd')"
              @focus="posicionarCursorFim"
              @click="posicionarCursorFim"
              class="mt-0 pt-0"
              inputmode="numeric"
              type="text"
              :readonly="somenteLeituraCotacao"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="5"> <v-divider></v-divider> </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block font-weight-bold"
              >Total:</v-label
            >
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              hide-details
              v-model="requisicaoServico.total"
              class="mt-0 pt-0"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="modoAprovacaoLimite">
          <v-col cols="12">
            <!--<v-textarea
              v-model="justificativaAprovacao"
              label="Justificativa"
              outlined
              dense
              maxlength="500"
              counter
            />-->
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="5000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            v-if="modoAprovacaoLimite"
            @click="declinarPedido"
            :disabled="!isInactive(idModulo)"
            color="secondary"
            class="mr-4"
          >
            Declinar
          </v-btn>
          <v-btn to="/requisicaoServico" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn
            v-if="podeGerarPedido"
            @click="gerarPedido"
            :disabled="overlay"
            color="primary"
            class="mr-4"
          >
            Gerar Pedido
          </v-btn>
          <v-btn
            v-if="podeSalvarCotacao"
            @click="salvarPedido"
            :disabled="overlay"
            color="success"
            class="mr-4"
          >
            Salvar
          </v-btn>
          <v-btn
            v-if="modoAprovacaoLimite"
            @click="aprovarPedido"
            :disabled="!isApproving(idModulo)"
            color="success"
            class="mr-4"
          >
            Aprovar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import {
  gerarPedidoRequisicaoAsync,
  aprovarPedidoRequisicaoAsync,
  declinarPedidoRequisicaoAsync,
  salvarPedidoRequisicaoAsync,
  obterRequisicaoPorIdAsync,
} from "../../../services/requisicaoServicoService";
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  getUserRoles,
} from "@/services/loginService";

export default {
  name: "aprovarRequisicao",
  props: {
    modoAprovacaoLimite: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    idModulo: 8,
    prioridade: null,
    overlay: false,
    valid: true,
    id: null,
    condicaoPagamentoSelected: null,
    requisitante: null,
    idOrdemServico: null,
    descricao: null,
    observacao: null,
    observacaoAprovador: null,
    autorizado: null,
    local: null,
    unidadeAdm: null,
    fornecedorSelected: null,
    produtosL: [],
    indexEdit: null,
    errorMessage: false,
    errorMessageValue: null,
    justificativaAprovacao: "",
    headers: [
      { text: "Produto/Serviço", value: "descricao", sortable: false },
      { text: "Quantidade", value: "quantidadeAprovada", width: "10%" },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Entrega", value: "prazo", sortable: false },
      { text: "Marca", value: "marca", sortable: false },
      { text: "Valor Unit", value: "valorUnitario", sortable: false },
      { text: "Desconto", value: "desconto", sortable: false },
      { text: "Total", value: "total", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicaoServico", ["requisicaoServico"]),
    ...mapState("condicaoPagamento", ["condicoes"]),
    ...mapState("fornecedor", ["fornecedores"]),

    filteredFornecedor() {
      return this.fornecedores
        .filter((f) => {
          return f.ativo === true;
        })
        .sort(function (a, b) {
          return b.id - a.id;
        });
    },
    somenteLeituraCotacao() {
      return (
        this.modoAprovacaoLimite ||
        this.requisicaoServico?.status === "LA"
      );
    },
    podeGerarPedido() {
      return (
        !this.modoAprovacaoLimite &&
        ["PA", "LA"].includes(this.requisicaoServico?.status)
      );
    },
    podeSalvarCotacao() {
      return (
        !this.modoAprovacaoLimite &&
        ["PA", "AL", "LD", "PG"].includes(this.requisicaoServico?.status)
      );
    },
  },
  methods: {
    ...mapActions("requisicaoServico", [
      "atualizarRequisicaoServico",
      "updateRequisicaoServico",
    ]),
    ...mapActions("pedido", ["upsertPedido"]),
    ...mapActions("fornecedor", ["atualizarFornecedores"]),
    ...mapActions("condicaoPagamento", ["atualizarCondicoes"]),
    isApproving(id) {
      return canApproveModule(id);
    },
    isInactive(id) {
      return canDeclineModule(id);
    },
    onInput(valorDigitado, item, propriedade) {
      const apenasNumeros = (valorDigitado || "").toString().replace(/\D/g, "");
      switch (propriedade) {
        case "valorUnitario":
          item.valorUnitario = apenasNumeros;
          if (!item.valorUnitario || isNaN(item.valorUnitario)) {
            this.$set(item, "valorUnitario", 0);
            this.$set(item, "valorUnitarioLocal", "");
            this.calcularSubtotais(item);
            break;
          }
          var valorNumericoU = parseFloat(item.valorUnitario) / 10000;
          this.$set(item, "valorUnitario", valorNumericoU);
          this.$set(item, "valorUnitarioLocal", this.formatarDecimal4(valorNumericoU));
          this.calcularSubtotais(item);
          break;
        case "desconto":
          item.desconto = apenasNumeros;
          if (!item.desconto || isNaN(item.desconto)) {
            this.$set(item, "desconto", 0);
            this.$set(item, "descontoLocal", "");
            this.calcularSubtotais(item);
            break;
          }
          var valorNumericoP = parseFloat(item.desconto) / 10000;
          this.$set(item, "desconto", valorNumericoP);
          this.$set(item, "descontoLocal", this.formatarDecimal4(valorNumericoP));
          this.calcularSubtotais(item);
          break;
        case "acrescimo":
          this.requisicaoServico.acrescimo = apenasNumeros;
          if (
            !this.requisicaoServico.acrescimo ||
            isNaN(this.requisicaoServico.acrescimo)
          ) {
            this.$set(this.requisicaoServico, "acrescimo", 0);
            this.$set(this.requisicaoServico, "acrescimoLocal", "");
            this.calcularTotais();
            break;
          }
          var valorNumericoA =
            parseFloat(this.requisicaoServico.acrescimo) / 10000;
          this.$set(this.requisicaoServico, "acrescimo", valorNumericoA);
          this.$set(this.requisicaoServico, "acrescimoLocal", this.formatarDecimal4(valorNumericoA));
          this.calcularTotais();
          break;
        default:
          this.requisicaoServico.desconto = apenasNumeros;
          if (
            !this.requisicaoServico.desconto ||
            isNaN(this.requisicaoServico.desconto)
          ) {
            this.$set(this.requisicaoServico, "desconto", 0);
            this.$set(this.requisicaoServico, "descontoLocal", "");
            this.calcularTotais();
            break;
          }
          var valorNumericoDa =
            parseFloat(this.requisicaoServico.desconto) / 10000;
          this.$set(this.requisicaoServico, "desconto", valorNumericoDa);
          this.$set(this.requisicaoServico, "descontoLocal", this.formatarDecimal4(valorNumericoDa));
          this.calcularTotais();
          break;
      }
    },
    formatarDecimal4(valor) {
      return (parseFloat(valor) || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    },
    parseDecimal(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return 0;
      }
      if (typeof valor === "number") {
        return valor;
      }
      return (
        parseFloat(valor.toString().replace(/\./g, "").replace(",", ".")) || 0
      );
    },
    posicionarCursorFim(event) {
      const input = event?.target;
      if (!input || typeof input.setSelectionRange !== "function") {
        return;
      }

      this.$nextTick(() => {
        const fim = input.value.length;
        input.setSelectionRange(fim, fim);
      });
    },
    isItemAprovado(item) {
      return Number(item?.quantidadeAprovada ?? 0) > 0;
    },
    normalizarItemPedido(item, index) {
      const valorUnitario = this.parseDecimal(item.valorUnitario);
      const desconto = this.parseDecimal(item.desconto);
      const total =
        item.total !== null && item.total !== undefined
          ? this.parseDecimal(item.total)
          : Math.max(
              valorUnitario * Number(item.quantidadeAprovada ?? 0) - desconto,
              0
            );

      return {
        ...item,
        index,
        valorUnitario,
        desconto,
        total,
        valorUnitarioLocal: this.formatarDecimal4(valorUnitario),
        descontoLocal: this.formatarDecimal4(desconto),
      };
    },
    calcularSubtotais(item) {
      const valorUnitario = this.parseDecimal(item.valorUnitarioLocal);
      const quantidade = item.quantidadeAprovada ?? 0;

      const descontoAplicado = this.parseDecimal(item.descontoLocal);

      let totalCalculado = valorUnitario * quantidade - descontoAplicado;
      this.$set(item, "total", totalCalculado < 0 ? 0 : totalCalculado);

      this.$set(this.requisicaoServico, "subtotal", this.produtosL.reduce(
        (sum, i) => sum + (i.total || 0),
        0
      ));

      this.calcularTotais();
    },
    calcularTotais() {
      const subtotal = this.parseDecimal(this.requisicaoServico.subtotal);
      const desconto = this.parseDecimal(this.requisicaoServico.descontoLocal);
      const acrescimo = this.parseDecimal(this.requisicaoServico.acrescimoLocal);

      let totalCalculado = subtotal + acrescimo - desconto;
      this.$set(this.requisicaoServico, "total", totalCalculado < 0 ? 0 : totalCalculado);
    },
    async gerarPedido() {
      if (!this.$refs.form.validate()) {
        this.errorMessageValue = "Preencha todos os campos obrigatórios.";
        this.errorMessage = true;
        return;
      }
      this.overlay = true;
      try {
        const tinhaPedidoAnterior = Number(this.requisicaoServico.idPedido || 0) > 0;
        this.requisicaoServico.idFornecedor =
          this.fornecedorSelected?.id || this.requisicaoServico.idFornecedor;
        this.requisicaoServico.idCondicaoPagamento =
          this.condicaoPagamentoSelected.id;
        const payload = {
          ...this.requisicaoServico,
          produtos: this.produtosL,
        };
        const resposta = await gerarPedidoRequisicaoAsync(
          payload
        );
        if (!resposta || resposta?.status != 200) {
          this.$alert(
            resposta?.message ||
              resposta?.Message ||
              "Nao foi possivel gerar o pedido.",
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          const requisicaoAtualizada =
            resposta.data?.requisicaoServico ||
            resposta.data?.RequisicaoServico ||
            resposta.data;
          const pedidoCriado = resposta.data?.pedido || resposta.data?.Pedido;

          this.updateRequisicaoServico(
            this.mountObjRequisicao(requisicaoAtualizada)
          );
          if (requisicaoAtualizada?.status === "AL") {
            this.$store.dispatch("ui/showSnackbar", {
              text:
                "O total excede seu limite. A requisição foi enviada para aprovação do pedido.",
              color: "warning",
              timeout: 5000,
            });
            this.$router.push("/requisicaoServico");
            return;
          }
          if (pedidoCriado) {
            this.upsertPedido(pedidoCriado);
          } else {
            await this.$store.dispatch("pedido/atualizarPedidos");
          }
          this.$store.dispatch("ui/showSnackbar", {
            text: tinhaPedidoAnterior
              ? "Novo pedido gerado com sucesso. O pedido anterior foi cancelado."
              : "Pedido gerado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/requisicaoServico");
        }
      } finally {
        this.overlay = false;
      }
    },
    async aprovarPedido() {
      this.overlay = true;
      try {
        const resposta = await aprovarPedidoRequisicaoAsync(
          this.requisicaoServico.id
        );
        if (!resposta || resposta?.status !== 200) {
          this.$alert(
            resposta?.message ||
              resposta?.Message ||
              "Não foi possível aprovar a cotação.",
            "Desculpe, falha na operação!",
            "error"
          );
          return;
        }

        const requisicaoAtualizada =
          resposta.data?.requisicaoServico ||
          resposta.data?.RequisicaoServico ||
          resposta.data;

        this.atualizarRequisicaoServico(requisicaoAtualizada);
        this.updateRequisicaoServico(requisicaoAtualizada);
        this.$store.dispatch("ui/showSnackbar", {
          text:
            "Cotação aprovada! O comprador já pode retornar e gerar o pedido.",
          color: "success",
          timeout: 5000,
        });
        this.$router.push("/requisicaoServico");
      } finally {
        this.overlay = false;
      }
    },
    async declinarPedido() {
      try {
        await this.$confirm(
          "Tem certeza que deseja declinar esta cotação?",
          "Confirmação",
          {
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            type: "warning",
          }
        );

        this.overlay = true;
        try {
          const resposta = await declinarPedidoRequisicaoAsync(
            this.requisicaoServico.id,
            this.justificativaAprovacao
          );
          if (!resposta || resposta?.status !== 200) {
            this.$alert(
              resposta?.message || "Não foi possível declinar a cotação.",
              "Desculpe, falha na operação!",
              "error"
            );
            return;
          }

          this.atualizarRequisicaoServico(resposta.data);
          this.updateRequisicaoServico(resposta.data);
          this.$store.dispatch("ui/showSnackbar", {
            text: "Cotação declinada.",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/requisicaoServico");
        } finally {
          this.overlay = false;
        }
      } catch (e) {
        void e;
      }
    },
    async salvarPedido() {
      if (!this.$refs.form.validate()) {
        this.errorMessageValue = "Preencha todos os campos obrigatórios.";
        this.errorMessage = true;
        return;
      }
      this.overlay = true;
      try {
        const statusAnterior = this.requisicaoServico.status;
        this.requisicaoServico.idFornecedor =
          this.fornecedorSelected?.id || this.requisicaoServico.idFornecedor;
        this.requisicaoServico.idCondicaoPagamento =
          this.condicaoPagamentoSelected.id;
        const payload = {
          ...this.requisicaoServico,
          produtos: this.produtosL,
        };
        const resposta = await salvarPedidoRequisicaoAsync(
          payload
        );
        if (!resposta || resposta?.status != 200) {
          this.$alert(
            resposta?.message ||
              resposta?.Message ||
              "Nao foi possivel salvar o pedido.",
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          const requisicaoAtualizada = this.mountObjRequisicao(resposta.data);
          this.atualizarRequisicaoServico(requisicaoAtualizada);
          this.updateRequisicaoServico(requisicaoAtualizada);
          this.$store.dispatch("ui/showSnackbar", {
            text:
              statusAnterior === "PG" &&
              requisicaoAtualizada.status === "PA"
                ? "Cotação atualizada. A requisição retornou para Analisado pelo Gestor."
                : statusAnterior === "AL" &&
                  requisicaoAtualizada.status === "PA"
                ? "Cotação salva e retornada para Analisado pelo Gestor, pois o total ficou dentro do limite."
                : statusAnterior === "LD" &&
                  requisicaoAtualizada.status === "PA"
                ? "Cotação ajustada e retornada para Analisado pelo Gestor."
                : "Salvo com sucesso!",
            color: "success",
            timeout: 5000,
          });
          if (
            ["AL", "LD", "PG"].includes(statusAnterior) &&
            requisicaoAtualizada.status === "PA"
          ) {
            this.$router.push("/requisicaoServico");
          }
        }
      } finally {
        this.overlay = false;
      }
    },
    mountObjRequisicao(obj) {
      const produtos =
        obj?.produtos || obj?.Produtos || this.requisicaoServico.produtos;

      return {
        ...this.requisicaoServico,
        ...(obj || {}),
        status: obj == null ? "D" : obj.status,
        produtos,
        observacaoAutorizador: this.observacaoAprovador,
        idFornecedor:
          this.fornecedorSelected != null
            ? this.fornecedorSelected.id
            : this.requisicaoServico.idFornecedor,
      };
    },

    findFornecedor(fornecedorId) {
      return this.filteredFornecedor.find((f) => f.id === fornecedorId);
    },
    findPagamento(pagamentoId) {
      return this.condicoes.find((c) => c.id === pagamentoId);
    },
    async carregarTela() {
      this.overlay = true;
      try {
        const dependencias = [];
        if (!this.fornecedores || this.fornecedores.length === 0) {
          dependencias.push(this.atualizarFornecedores());
        }
        if (!this.condicoes || this.condicoes.length === 0) {
          dependencias.push(this.atualizarCondicoes());
        }
        await Promise.all(dependencias);

        const idRota = Number(this.$route.query.id);
        if (idRota > 0) {
          const resposta = await obterRequisicaoPorIdAsync(idRota);
          if (!resposta || resposta.status !== 200) {
            this.$alert(
              resposta?.message || "Requisição de serviço não encontrada.",
              "Desculpe, falha na operação!",
              "error"
            );
            this.$router.push("/requisicaoServico");
            return;
          }
          this.atualizarRequisicaoServico(resposta.data);
        }

        if (!this.requisicaoServico?.id) {
          this.$router.push("/requisicaoServico");
          return;
        }

        if (
          this.modoAprovacaoLimite &&
          this.requisicaoServico.status !== "AL"
        ) {
          this.$alert(
            "Esta requisição não está aguardando aprovação do pedido.",
            "Operação indisponível",
            "warning"
          );
          this.$router.push("/requisicaoServico");
          return;
        }

        this.inicializarCampos();
      } finally {
        this.overlay = false;
      }
    },
    inicializarCampos() {
      this.prioridade =
        this.requisicaoServico.prioridade === "Normal" ||
        this.requisicaoServico.prioridade === 1
          ? "Normal"
          : "Emergencial";
      this.id = this.requisicaoServico.id;
      this.requisitante = this.requisicaoServico.requisitante;
      this.idOrdemServico =
        this.requisicaoServico.idOrdemServico == null ||
        this.requisicaoServico.idOrdemServico == 0
          ? "NA"
          : this.requisicaoServico.idOrdemServico;
      this.produtosL = (this.requisicaoServico.produtos || [])
        .filter(this.isItemAprovado)
        .map((item, itemIndex) => this.normalizarItemPedido(item, itemIndex));
      this.autorizado = this.requisicaoServico.autorizado;
      this.unidadeAdm = this.requisicaoServico.unidadeAdm;
      this.local = this.requisicaoServico.local;
      this.observacao = this.requisicaoServico.observacao;
      this.$set(
        this.requisicaoServico,
        "acrescimoLocal",
        this.formatarDecimal4(this.requisicaoServico.acrescimo)
      );
      this.$set(
        this.requisicaoServico,
        "descontoLocal",
        this.formatarDecimal4(this.requisicaoServico.desconto)
      );
      this.observacaoAprovador =
        this.requisicaoServico.observacaoAutorizador;
      this.fornecedorSelected = this.findFornecedor(
        this.requisicaoServico.idFornecedor
      );
      this.condicaoPagamentoSelected = this.findPagamento(
        this.requisicaoServico.idCondicaoPagamento
      );

      for (let i = 0; i < this.produtosL.length; i++) {
        this.calcularSubtotais(this.produtosL[i]);
      }
      this.calcularTotais();
      const roles = getUserRoles();
      if (roles) {
        this.regras = roles;
      }
    },
  },
  created: function () {
    this.carregarTela();
  },
};
</script>
